/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Additionalinformation1Inputs */

const en__field_additionalinformation1 = /** @type {(inputs: _Field_Additionalinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional import information`)
};

const de__field_additionalinformation1 = /** @type {(inputs: _Field_Additionalinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgendes möchte ich noch mitteilen:`)
};

/**
* | output |
* | --- |
* | "Additional import information" |
*
* @param {_Field_Additionalinformation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_additionalinformation1 = /** @type {((inputs?: _Field_Additionalinformation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Additionalinformation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_additionalinformation1(inputs)
	return de__field_additionalinformation1(inputs)
});
export { _field_additionalinformation1 as "_field_additionalInformation" }